import React from 'react';
import { css } from 'aphrodite';
import styles from './available-drivers-list-styles';
import { ContentCard, ContentRow } from '../common';


const AvailableDrivers = (props) => (
  <div className={css(styles.root)}>
    <ContentCard title={'Available drivers'}>
      {props.availableDrivers.list.map(driver => (
        <ContentRow key={driver.driverId}>
          <img src={driver.image} className={css(styles.driverImg)} />
          <div className={css(styles.driverName)}>{driver.firstName} {driver.lastName}</div>
          <div style={{ flex: 1 }} />
          <div>{driver.phone}</div>
        </ContentRow>
      ))}
    </ContentCard>
  </div>
);

export default AvailableDrivers;



// WEBPACK FOOTER //
// ./src/components/available-drivers-list/available-drivers-list-view.js